export default class ScrollTo {
    getHeaderHeight() {
        if (!this.header) {
            this.header = document.querySelector('header');
        }

        return this.header ? this.header.offsetHeight : 0;
    }

    element(elem, topOffset = 10) {
        if (!elem) {
            return false;
        }

        let elemYPos = elem.getBoundingClientRect().top;
        let yPos = window.pageYOffset + elemYPos - this.getHeaderHeight() - topOffset;

        this.smoothScroll(0, yPos);
    }

    top() {
        this.smoothScroll(0, 0);
    }

    smoothScroll(x, y) {
        if ('scrollBehavior' in document.documentElement.style) {
            window.scrollTo({
                top: y,
                left: x,
                behavior: 'smooth',
            });
        } else {
            window.scrollTo(x, y); // TODO: implement smooth scroll or use lib
        }
    }
}

export const scrollTo = new ScrollTo();
